var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.897,
    height: 27.286,
    viewBox: "0 0 24.897 27.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book_15493602",
    transform: "translate(-72.064 -29.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_",
    transform: "translate(73.721 29.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_55_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    d: "M151.574,54.846a.938.938,0,0,1-.011.156c.014-.1.028-.2.04-.3a1.14,1.14,0,0,1-.079.291c.037-.091.076-.181.113-.272a1.374,1.374,0,0,1-.147.258l.178-.229a1.287,1.287,0,0,1-.232.232l.229-.178a1.216,1.216,0,0,1-.258.147l.272-.113a1.48,1.48,0,0,1-.291.079c.1-.014.2-.028.3-.04a5.857,5.857,0,0,1-.631.011H135.142c-.741,0-1.48,0-2.221,0a1.257,1.257,0,0,1-.178-.011c.1.014.2.028.3.04a1.14,1.14,0,0,1-.291-.079l.272.113a1.374,1.374,0,0,1-.258-.147l.229.178a1.287,1.287,0,0,1-.232-.232l.178.229a1.215,1.215,0,0,1-.147-.258c.037.091.076.181.113.272a1.479,1.479,0,0,1-.079-.291c.014.1.028.2.04.3a6.288,6.288,0,0,1-.011-.73V32.205a1.311,1.311,0,0,1,.011-.184c-.014.1-.028.2-.04.3a1.139,1.139,0,0,1,.079-.291c-.037.091-.076.181-.113.272a1.373,1.373,0,0,1,.147-.258l-.178.229a1.287,1.287,0,0,1,.232-.232l-.229.178a1.215,1.215,0,0,1,.258-.147l-.272.113a1.48,1.48,0,0,1,.291-.079c-.1.014-.2.028-.3.04a5.858,5.858,0,0,1,.631-.011h15.915c.741,0,1.48,0,2.221,0a1.257,1.257,0,0,1,.178.011c-.1-.014-.2-.028-.3-.04a1.139,1.139,0,0,1,.291.079l-.272-.113a1.373,1.373,0,0,1,.258.147l-.229-.178a1.287,1.287,0,0,1,.232.232l-.178-.229a1.216,1.216,0,0,1,.147.258c-.037-.091-.076-.181-.113-.272a1.48,1.48,0,0,1,.079.291c-.014-.1-.028-.2-.04-.3a6.288,6.288,0,0,1,.011.73v21.17c0,.3,0,.594,0,.889v.037a1.132,1.132,0,0,0,2.264,0V32.2a3.047,3.047,0,0,0-.051-.481,2.284,2.284,0,0,0-.979-1.457,2.745,2.745,0,0,0-1.715-.391h-17.53c-.232,0-.467-.008-.7,0a2.321,2.321,0,0,0-1.627.713,2.386,2.386,0,0,0-.637,1.59V54.826a2.311,2.311,0,0,0,2.38,2.326h18.575a2.3,2.3,0,0,0,2.286-2.3,1.133,1.133,0,0,0-2.267,0Z",
    transform: "translate(-130.6 -29.867)",
    fill: "#3f8dfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_",
    transform: "translate(72.064 34.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    d: "M73.2,207.264h3.257a1.132,1.132,0,0,0,0-2.264H73.2a1.132,1.132,0,0,0,0,2.264Z",
    transform: "translate(-72.064 -205)",
    fill: "#3f8dfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_",
    transform: "translate(72.064 39.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_43_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    d: "M76.454,383.4H73.2a1.132,1.132,0,0,0,0,2.264h3.257a1.132,1.132,0,1,0,0-2.264Z",
    transform: "translate(-72.064 -383.4)",
    fill: "#3f8dfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_",
    transform: "translate(72.064 44.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_37_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    d: "M76.454,560.6H73.2a1.132,1.132,0,1,0,0,2.264h3.257a1.132,1.132,0,1,0,0-2.264Z",
    transform: "translate(-72.064 -560.6)",
    fill: "#3f8dfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_",
    transform: "translate(72.064 49.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    d: "M76.454,739H73.2a1.132,1.132,0,1,0,0,2.264h3.257a1.132,1.132,0,1,0,0-2.264Z",
    transform: "translate(-72.064 -739)",
    fill: "#3f8dfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(78.899 36.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    transform: "translate(2.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    d: "M403.58,277.818a3.018,3.018,0,0,1-.025.391c.014-.1.028-.2.04-.3a2.967,2.967,0,0,1-.2.73c.037-.091.076-.181.113-.272a3.055,3.055,0,0,1-.391.671l.178-.229a3.127,3.127,0,0,1-.521.521l.229-.178a3.054,3.054,0,0,1-.671.391l.272-.113a3.1,3.1,0,0,1-.73.2c.1-.014.2-.028.3-.04a3.006,3.006,0,0,1-.781,0c.1.014.2.028.3.04a2.97,2.97,0,0,1-.73-.2l.272.113a3.054,3.054,0,0,1-.671-.391l.229.178a3.124,3.124,0,0,1-.521-.521l.178.229a3.054,3.054,0,0,1-.391-.671c.037.091.076.181.113.272a3.1,3.1,0,0,1-.2-.73c.014.1.028.2.04.3a3.008,3.008,0,0,1,0-.781c-.014.1-.028.2-.04.3a2.967,2.967,0,0,1,.2-.73c-.037.091-.076.181-.113.272a3.054,3.054,0,0,1,.391-.671l-.178.229a3.123,3.123,0,0,1,.521-.521l-.229.178a3.056,3.056,0,0,1,.671-.391l-.272.113a3.1,3.1,0,0,1,.73-.2c-.1.014-.2.028-.3.04a3.008,3.008,0,0,1,.781,0c-.1-.014-.2-.028-.3-.04a2.969,2.969,0,0,1,.73.2l-.272-.113a3.055,3.055,0,0,1,.671.391l-.229-.178a3.126,3.126,0,0,1,.521.521l-.178-.229a3.055,3.055,0,0,1,.391.671c-.037-.091-.076-.181-.113-.272a3.1,3.1,0,0,1,.2.73c-.014-.1-.028-.2-.04-.3.014.13.023.258.025.39a1.175,1.175,0,0,0,.331.8,1.133,1.133,0,0,0,1.933-.8,4,4,0,0,0-.7-2.275,4.608,4.608,0,0,0-.99-1.013,3.967,3.967,0,0,0-1.047-.546,4.046,4.046,0,0,0-4.383,1.186,4.527,4.527,0,0,0-.727,1.228,4.041,4.041,0,0,0,.314,3.512,3.97,3.97,0,0,0,1.715,1.559,5.036,5.036,0,0,0,.659.255,4.476,4.476,0,0,0,.75.13,4.019,4.019,0,0,0,1.234-.076,3.93,3.93,0,0,0,2.185-1.307,4.542,4.542,0,0,0,.77-1.333,3.946,3.946,0,0,0,.221-1.319,1.13,1.13,0,1,0-2.261,0Z",
    transform: "translate(-397.729 -273.759)",
    fill: "#3f8dfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "translate(0 5.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    d: "M326.478,488.987a6.385,6.385,0,0,0-1.146-3.662,6.943,6.943,0,0,0-1.483-1.522,6.33,6.33,0,0,0-1.689-.9,6.453,6.453,0,0,0-7.023,1.91,6.879,6.879,0,0,0-1.163,2.012,6.287,6.287,0,0,0-.374,2.156,1.148,1.148,0,0,0,1.132,1.132h9.307c.43,0,.86.008,1.29,0h.017a1.14,1.14,0,0,0,1.132-1.129,1.152,1.152,0,0,0-1.132-1.132h-9.307c-.43,0-.86-.009-1.29,0h-.017l1.132,1.132a5.369,5.369,0,0,1,.048-.707c-.014.1-.028.2-.04.3a5.4,5.4,0,0,1,.371-1.358c-.037.091-.076.181-.113.272a5.565,5.565,0,0,1,.7-1.188l-.178.229a5.5,5.5,0,0,1,.942-.942l-.229.178a5.385,5.385,0,0,1,1.189-.7l-.272.113a5.524,5.524,0,0,1,1.358-.371c-.1.014-.2.028-.3.04a5.383,5.383,0,0,1,1.415,0c-.1-.014-.2-.028-.3-.04a5.4,5.4,0,0,1,1.358.371l-.272-.113a5.564,5.564,0,0,1,1.189.7l-.229-.178a5.5,5.5,0,0,1,.942.942l-.178-.229a5.383,5.383,0,0,1,.7,1.188c-.037-.091-.076-.181-.113-.272a5.522,5.522,0,0,1,.371,1.358c-.014-.1-.028-.2-.04-.3a5.9,5.9,0,0,1,.048.707,1.128,1.128,0,1,0,2.255,0Z",
    transform: "translate(-313.6 -482.545)",
    fill: "#3f8dfb"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage1);
export default __webpack_public_path__ + "static/media/usage-1.c1356118b72b96d26399f5a5fe292778.svg";
export { ForwardRef as ReactComponent };